/** Capitalize the first letter of the provided string */
export const toSentenceCase = (str: string = '') => {
  const [first, ...rest] = str;
  return [first?.toUpperCase(), ...rest].join('');
};

/**
 * Capitalize each word of the provided string, treating underscores as word
 * separator.
 *
 * Note: doesn't account for punctuation other than underscore
 */
export const toTitleCase = (words: string = '') =>
  words.split(/[ _]/g).map(toSentenceCase).join(' ');

/**
 * Pluralize the given word
 *
 * @example
 * ```ts
 * // simple forms have "s" appended
 * plural('dog') // dogs
 * plural('dog', 0) // dogs
 * plural('dog', 1) // dog
 * plural('dog', 2) // dogs
 *
 * // plurals which don't just append "s"
 * plural('city', 0, 'cities') // cities
 * plural('city', 1, 'cities') // city
 * plural('city', 2, 'cities') // cities
 * ```
 *
 * @param word word in the singular form
 * @param count defaults to 0
 */
export const plural = (word: string, count: number = 0, plural?: string) =>
  count == 0 || count > 1 ? (plural ?? word + 's') : word;
